import { render, staticRenderFns } from "./basicCard.vue?vue&type=template&id=0653509a&scoped=true"
import script from "./basicCard.vue?vue&type=script&lang=js"
export * from "./basicCard.vue?vue&type=script&lang=js"
import style0 from "./basicCard.vue?vue&type=style&index=0&id=0653509a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0653509a",
  null
  
)

export default component.exports